import { render, staticRenderFns } from "./Terrain.vue?vue&type=template&id=21b859ae&"
import script from "./Terrain.vue?vue&type=script&lang=js&"
export * from "./Terrain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports